import React, { useState } from 'react';
import { Grid, Box, Tabs, Tab } from '@material-ui/core';
import {
  Create,
  SimpleForm,
  TextInput,
  ImageInput,
  ImageField,
  SelectInput,
  ReferenceInput,
  required,
} from 'react-admin';
import Toolbar from '../resource-toolbar';
import { LanguageChanger } from '../fields';
import { useServerValidation, useLanguageChange, getStyle } from '../../helpers';
import { PROD_STATUSES, LANGUAGES } from '../../constants';

const tabs = [
  { id: 'category', name: 'Category' },
  { id: 'subcategory', name: 'SubCategory' },
];

export default (props) => {
  const [currentTab, setCurrentTab] = useState('category');
  const { onFailure } = useServerValidation();
  const [defaultLanguage] = LANGUAGES;
  const { language, onLanguageChange } = useLanguageChange(defaultLanguage);
  return (
    <Grid item lg={6} md={8} xs={12}>
      <Box boxShadow={3} mt={2}>
        <Tabs
          variant="fullWidth"
          centered
          value={currentTab}
          indicatorColor="primary"
          onChange={(event, value) => setCurrentTab(value)}
        >
          {tabs.map((choice) => (
            <Tab key={choice.id} label={choice.name} value={choice.id} />
          ))}
        </Tabs>
      </Box>
      {currentTab === 'category' && (
        <Create {...props} onFailure={onFailure}>
          <SimpleForm toolbar={<Toolbar resourceName="categories" />}>
            <SelectInput
              source="status"
              choices={PROD_STATUSES}
              fullWidth
              defaultValue="New"
              validate={required()}
            />
            <ImageInput source="files" label="Photo" accept="image/*" validate={required()}>
              <ImageField source="photo" title="Category Photo" />
            </ImageInput>
            <LanguageChanger language={language} onLanguageChange={onLanguageChange} />
            <TextInput style={getStyle(language, '_en')} source="name" fullWidth validate={required()} />
            <TextInput style={getStyle(language, '_fr')} source="name_fr" fullWidth />
            <TextInput style={getStyle(language, '_jp')} source="name_jp" fullWidth />
            <TextInput style={getStyle(language, '_cn')} source="name_cn" fullWidth />
            <TextInput style={getStyle(language, '_de')} source="name_de" fullWidth />
            <TextInput style={getStyle(language, '_kr')} source="name_kr" fullWidth />
            <TextInput style={getStyle(language, '_es')} source="name_es" fullWidth />
          </SimpleForm>
        </Create>
      )}
      {currentTab === 'subcategory' && (
        <Create {...props} onFailure={onFailure}>
          <SimpleForm toolbar={<Toolbar resourceName="categories" />}>
            <SelectInput
              source="status"
              choices={PROD_STATUSES}
              fullWidth
              defaultValue="New"
              validate={required()}
            />
            <ReferenceInput
              source="parent_id"
              reference="categories"
              filter={{ parent_id: null }}
              sort={{ field: 'name', order: 'ASC' }}
              fullWidth
            >
              <SelectInput optionText="name" validate={required()} />
            </ReferenceInput>
            <ImageInput source="files" label="Photo" accept="image/*">
              <ImageField source="photo" title="Category Photo" />
            </ImageInput>
            <TextInput source="name" fullWidth validate={required()} />
            <TextInput source="name_fr" fullWidth />
            <TextInput source="name_jp" fullWidth />
            <TextInput source="name_cn" fullWidth />
            <TextInput source="name_de" fullWidth />
            <TextInput source="name_kr" fullWidth />
            <TextInput source="name_es" fullWidth />
          </SimpleForm>
        </Create>
      )}
    </Grid>
  );
};
